export function directiveResolveParams (el, binding, param, defaultValue = null) {
    if(binding.value && typeof binding.value === 'object' && binding.value[param] !== undefined){
        return binding.value[param];
    }
    return el.dataset[param] || defaultValue;
}

export function moveElementTo (source, destination) {
    let dummy = document.createElement('span')
    source.before(dummy)
    destination.before(source)
    dummy.replaceWith(destination)
}

export function formDataToObject (formData) {
    let params = {};
    formData.forEach((value, key) => {
        if(!key.includes('[]')) {
            params[key] = value;
        } else {
            key = key.replace('[]', '');
            if(!params[key]){
                params[key] = [];
            }
            params[key].push(value);
        }
    });
    return params;
}

export function get_ga_clientid() {
    var cookie = {};
    document.cookie.split(';').forEach(function(el) {
        var splitCookie = el.split('=');
        var key = splitCookie[0].trim();
        var value = splitCookie[1];
        cookie[key] = value;
    });
    return cookie["_ga"] ? cookie["_ga"].substring(6) : null;
}

export function pushToLayer(event, datas) {
    let typeDevice = 'Desktop';
    if (window.innerWidth < 768) {
        typeDevice = 'Mobile';
    } else if (window.innerWidth < 1024) {
        typeDevice = 'Tablette';
    }

    if(event == 'cta_rappel' && typeDevice == 'Mobile'){
        event = 'cta_rappel_mobile';
    }
    const pad = (num) => String(num).padStart(2, '0');
    const now = new Date();
    const timestamp = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}:${String(now.getMilliseconds()).padStart(3, '0')}`;

    window.dataLayer = window.dataLayer || [];
    let defaultDatas = {
        'event': event,
        'timestamp': timestamp,
    }

    const mergedData = {...defaultDatas, ...datas};
    if (window.localStorage && localStorage.getItem('dev-gta') === '1') {
        console.log(mergedData);
    }
    window.dataLayer.push(mergedData);
}

export function errorsToPipedString(errors) {
    let pipedString = '';
    if (errors) {
        let errorValues = Object.values(errors).filter(value => value !== null && value !== undefined && value !== '' && typeof value != 'object' && value !== false);
        return errorValues.join('|');
    }
    return pipedString;
}

export function formatPrice(value, locale = 'fr-FR', currency = 'EUR') {
    if (typeof value !== 'number') {
        value = parseFloat(value);
    }

    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(value);
}
